export const AppName = 'LeShuttle'
export class Logger {
  constructor (context, level) {
    // 1: Error, 2: Warning, 3: info, 4: Log
    this.level = typeof level === 'undefined' ? 4 : level

    this.prefix = `${AppName} | ${context} | `
  }

  hasNativeSupport () {
    return typeof console !== 'undefined'
  }

  formatMessage (message) {
    return this.prefix + message
  }

  error (message) {
    if (this.level > 0 && this.hasNativeSupport()) {
      console.error(this.formatMessage(message))
    }
  }

  warn (message) {
    if (this.level > 1 && this.hasNativeSupport()) {
      console.warn(this.formatMessage(message))
    }
  }

  info (message) {
    if (this.level > 2 && this.hasNativeSupport()) {
      console.info(this.formatMessage(message))
    }
  }

  log (message) {
    if (this.level > 3 && this.hasNativeSupport()) {
      console.log(this.formatMessage(message))
    }
  }
}
